import {Box} from '@mantine/core';
import type {FC} from 'react';
import {HOWTV_COMPANY_ADDRESS} from '../../../core/entities/shared/howtvInfo';
import {CommonLink} from '../../../shared/components/CommonLink';
import {SectionTitle} from '../../../shared/components/SectionTitle';

const TEXT_CLASSNAME = 'leading text-black-1 text-base';
const TABLE_TD_CLASSNAME =
  'leading text-black-1 text-base border-black-1 border-collapse border-[1px]';

export const PublicText: FC = () => {
  return (
    <>
      <SectionTitle order={2} title="個人情報に関する公表文" />
      <Box className=" bg-white px-8 py-16 pc:px-32">
        <div className="mb-12">
          <p className={`${TEXT_CLASSNAME} text-right `}>
            制定年月日&nbsp;2018年9月18日
          </p>
          <p className={`${TEXT_CLASSNAME} text-right `}>
            最終改正年月日&nbsp;2026年4月27日
          </p>
        </div>
        <div className="mb-16">
          <h3 className="mb-12 bg-background-1 px-8 py-4 text-md font-bold leading text-black-1">
            ■&nbsp;個人情報の取扱いについて
          </h3>
          <p className={`${TEXT_CLASSNAME} mb-12`}>
            １．当社が取り扱う個人情報の利用目的
          </p>
          <table className="mb-12">
            <thead>
              <tr>
                <td className={`${TABLE_TD_CLASSNAME}`} />
                <td className={`${TABLE_TD_CLASSNAME}`}>
                  <strong>分類</strong>
                </td>
                <td className={`${TABLE_TD_CLASSNAME}`}>
                  <strong>利用目的</strong>
                </td>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td className={`${TABLE_TD_CLASSNAME}`}>①</td>
                <td className={`${TABLE_TD_CLASSNAME}`}>一般のお客様情報</td>
                <td className={`${TABLE_TD_CLASSNAME}`}>お問合せ対応のため</td>
              </tr>
              <tr>
                <td className={`${TABLE_TD_CLASSNAME}`}>②</td>
                <td className={`${TABLE_TD_CLASSNAME}`}>会員情報</td>
                <td className={`${TABLE_TD_CLASSNAME}`}>
                  会員情報管理のため
                  <br />
                  ダイレクトメール発送のため
                  <br />
                  スカウト配信のため
                  <br />
                  ユーザー様サポートのため
                  <br />
                  ご利用履歴管理のため
                  <br />
                  当社サービスのご案内のため
                  <br />
                  当社及び第三者の商品・サービス等の販売・提供、配送、支払い処理のため
                  <br />
                  お問合せ対応のため
                </td>
              </tr>
              <tr>
                <td className={`${TABLE_TD_CLASSNAME}`}>③</td>
                <td className={`${TABLE_TD_CLASSNAME}`}>
                  お取引先担当者様情報
                </td>
                <td className={`${TABLE_TD_CLASSNAME}`}>
                  契約上の権利義務の履行のため
                  <br />
                  当社の商品・サービス等のご案内のため
                  <br />
                  発注内容確認のため（通信記録等）
                  <br />
                </td>
              </tr>
              <tr>
                <td className={`${TABLE_TD_CLASSNAME}`}>④</td>
                <td className={`${TABLE_TD_CLASSNAME}`}>
                  ホームページからのお問い合わせ者情報
                </td>
                <td className={`${TABLE_TD_CLASSNAME}`}>
                  お問合せ内容の確認、回答のため
                  <br />
                </td>
              </tr>
              <tr>
                <td className={`${TABLE_TD_CLASSNAME}`}>⑤</td>
                <td className={`${TABLE_TD_CLASSNAME}`}>当社従業員情報</td>
                <td className={`${TABLE_TD_CLASSNAME}`}>
                  社員の雇用管理のために必要となる労務管理、給与管理、社会保険管理、勤務管理、入退社管理、健康・安全管理、教育・研修管理、福利厚生等のため
                </td>
              </tr>
              <tr>
                <td className={`${TABLE_TD_CLASSNAME}`}>⑥</td>
                <td className={`${TABLE_TD_CLASSNAME}`}>
                  当社への採用応募者情報（含む、人材紹介会社・採用媒体から取得する情報）
                </td>
                <td className={`${TABLE_TD_CLASSNAME}`}>
                  採用応募者への連絡と当社の採用業務管理のため
                </td>
              </tr>
              <tr>
                <td className={`${TABLE_TD_CLASSNAME}`}>⑦</td>
                <td className={`${TABLE_TD_CLASSNAME}`}>特定個人情報</td>
                <td className={`${TABLE_TD_CLASSNAME}`}>
                  番号法に定められた利用目的のため
                </td>
              </tr>
              <tr>
                <td className={`${TABLE_TD_CLASSNAME}`}>⑧</td>
                <td className={`${TABLE_TD_CLASSNAME}`}>
                  業務の受託に伴い、お客様からお預かりする個人情報
                </td>
                <td className={`${TABLE_TD_CLASSNAME}`}>
                  委託された当該業務を適切に遂行するため
                </td>
              </tr>
              <tr>
                <td className={`${TABLE_TD_CLASSNAME}`}>⑨</td>
                <td className={`${TABLE_TD_CLASSNAME}`}>
                  転職エージェントの情報
                </td>
                <td className={`${TABLE_TD_CLASSNAME}`}>
                  当社サービスの提供のため
                  <br />
                  お問い合わせ対応のため
                </td>
              </tr>
            </tbody>
          </table>
          <p className={`${TEXT_CLASSNAME}`}>
            2．クレジットカード情報の取扱いについて
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            当社は、クレジットカードによる決済業務を、決済代行サービス会社に委託しています。当社のシステムを介して当社サービスの会員等が入力したクレジットカード情報（クレジットカード番号、有効期限、セキュリティコード）は、決済代行サービス会社が保持しており、当社はクレジットカード情報を一切保持しません。
          </p>
        </div>
        <div className="mb-16">
          <h3 className="mb-12 bg-background-1 px-8 py-4 text-md font-bold leading text-black-1">
            ■&nbsp;保有個人データに関する事項の周知
          </h3>
          <p className={`${TEXT_CLASSNAME}`}>
            当社で保有している保有個人データ又は第三者提供記録に関して、ご本人様又はその代理人様からの利用目的の通知、開示、内容の訂正、追加又は削除、利用の停止、消去及び第三者への提供の停止の請求（以下、「開示等の請求」といいます）につきましては、以下の要領にて対応させていただきます。
          </p>
          <p className={`${TEXT_CLASSNAME} mb-12`}>
            ａ）事業者の名称
            <br />
            株式会社ハウテレビジョン
            <br />
            {HOWTV_COMPANY_ADDRESS}
            <br />
            代表取締役社長 音成 洋介
          </p>
          <p className={`${TEXT_CLASSNAME} mb-12`}>
            ｂ）個人情報の保護管理者
            <br />
            管理者名： 清水&nbsp;伸太郎
            <br />
            所属部署：コーポレート本部
            <br />
            連絡先：メールアドレス：soumu@howtelevision.jp&nbsp;TEL：03-6427-2862
          </p>
          <p className={`${TEXT_CLASSNAME} mb-12`}>
            ｃ）全ての保有個人データの利用目的
            <br />
            保有個人データの利用目的は、上記、■個人情報の取扱いについて１．当社が取り扱う個人情報の利用目的の①~⑨が該当します。
          </p>
          <p className={`${TEXT_CLASSNAME} mb-12`}>
            ｄ）保有個人データの取扱いに関する苦情の申し出先
            <br />
            株式会社ハウテレビジョン&nbsp;&nbsp;個人情報問合せ窓口
            <br />
            {HOWTV_COMPANY_ADDRESS}
            <br />
            メールアドレス：soumu@howtelevision.jp&nbsp;TEL：03-6427-2862
            <br />
            （受付時間&nbsp;10:00～19:00&nbsp;※土・日曜日、祝日、年末年始、ゴールデンウィークを除く）
          </p>
          <p className={`${TEXT_CLASSNAME} mb-12`}>
            ｅ）認定個人情報保護団体
            <br />
            現在、当社が加盟する認定個人情報保護団体はありません。
          </p>
          <p className={`${TEXT_CLASSNAME} mb-12`}>
            ｆ）保有個人データの開示等の求めに応じる手続き
            <br />
            1）開示等の求めの申し出先
            <br />
            開示等のお求めは、上記個人情報問合せ係にお申し出ください。
            <br />
            <br />
            2）開示等の求めに関するお手続き
            <br />
            ①お申し出受付け後、当社からご利用いただく所定の請求書様式「保有個人データ開示等請求書」を郵送いたします。
            <br />
            <br />
            ②ご記入いただいた請求書、代理人によるお求めの場合は代理人であることを確認する書類、手数料分の郵便為替（利用目的の通知並びに開示の請求の場合のみ）を上記個人情報問合せ係までご郵送ください。
            <br />
            <br />
            ③上記請求書を受領後、ご本人確認のため、当社に登録していただいている個人情報のうちご本人確認可能な2項目程度（例：電話番号と生年月日等）の情報をお問合せさせていただきます。
            <br />
            <br />
            ④回答は原則としてご本人に対して書面（封書郵送）にておこないます。
            <br />
            <br />
            3）代理人によるお求めの場合、代理人であることを確認する資料
            <br />
            開示等をお求めになる方が代理人様である場合は、代理人である事を証明する資料及び代理人様ご自身を証明する資料を同封してください。
            各資料に含まれる本籍地情報は都道府県までとし、それ以降の情報は黒塗り等の処理をしてください。
            また各資料は個人番号を含まないものをお送りいただくか、全桁を墨塗り等の処理をしてください。
            <br />
            <br />
            ①代理人である事を証明する資料
            <br />
            ＜開示等の求めをすることにつき本人が委任した代理人様の場合＞
            <br />
            本人の委任状（原本）
            <br />
            ＜代理人様が未成年者の法定代理人の場合＞いずれかの写し
            <br />
            戸籍謄本
            <br />
            住民票（続柄の記載されたもの）
            <br />
            その他法定代理権の確認ができる公的書類
            <br />
            ＜代理人様が成年被後見人の法定代理人の場合＞いずれかの写し
            <br />
            後見登記等に関する登記事項証明書
            <br />
            その他法定代理権の確認ができる公的書類
            <br />
            <br />
            ②代理人様ご自身を証明する資料
            <br />
            運転免許証
            <br />
            パスポート
            <br />
            健康保険の被保険者証
            <br />
            住民票
            <br />
            <br />
            4）利用目的の通知または開示のお求めについての手数料
            <br />
            1回のお求めにつき1000円（お送りいただく請求書等に郵便為替を同封していただきます。）
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            ｇ）保有個人データの取扱体制や講じている措置の内容
            <br />
            1）基本方針の策定
            <br />
            保有個人データの適正な取扱いの確保のため、「関係法令・ガイドライン等の遵守」、「質問及び苦情処理の窓口」等について「個人情報保護方針」を策定しています。
            <br />
            <br />
            2）保有個人データの取扱いに係る規律の整備
            <br />
            保有個人データは取得、利用、保存、提供、削除・廃棄等の段階ごとに、取扱方法、責任者・担当者及びその任務等について個人情報保護規程を策定しています。
            <br />
            <br />
            3）組織的安全管理措置
            <br />
            ①保有個人データの取扱いに関する責任者を設置するとともに、保有個人データを取り扱う従業者及び当該従業者が取り扱う保有個人データの範囲を明確化し、法や取扱規程に違反している事実又は兆候を把握した場合の責任者への報告連絡体制を整備しています。
            <br />
            ②保有個人データの取扱状況について、定期的に自己点検を実施するとともに、他部署や外部の者による監査を実施しています。
            <br />
            <br />
            4）人的安全管理措置
            <br />
            ①保有個人データの取扱いに関する留意事項について、従業者に定期的な研修を実施しています。
            <br />
            ②保有個人データを含む秘密保持に関する誓約書の提出を全従業者から受けています。
            <br />
            <br />
            5）物理的安全管理措置
            <br />
            ①保有個人データを取り扱う区域において、従業者の入退室管理及び持ち込む機器等の制限を行うとともに、権限を有しない者による保有個人データの閲覧を防止する措置を講じています。
            <br />
            ②保有個人データを取り扱う機器、電子媒体及び書類等の盗難又は紛失等を防止するための措置を講じるとともに、事業所内の移動を含め、当該機器、電子媒体等を持ち運ぶ場合、容易に保有個人データが判明しないよう措置を講じています。
            <br />
            <br />
            6）技術的安全管理措置
            <br />
            ①アクセス制御を実施して、担当者及び取り扱う個人情報データベース等の範囲を限定しています。
            <br />
            ②保有個人データを取り扱う情報システムを外部からの不正アクセス又は不正ソフトウェアから保護する仕組みを導入しています。
          </p>
        </div>
        <div className="mb-16">
          <p className="mb-12 bg-background-1 px-8 py-4 text-md font-bold leading text-black-1">
            ■&nbsp;個別サービスについての特則
          </p>
          <p className={`${TEXT_CLASSNAME} mb-12`}>
            当社が提供する以下の個別サービスに係る個人情報の保護については、以下の規約も適用されます。本個人情報保護方針と当該規約とで規定の内容が異なる場合は、当該規約の規定を優先して適用します。
          </p>
          <table className="mb-12">
            <thead>
              <tr>
                <td className={`${TABLE_TD_CLASSNAME}`}>
                  <strong>当社のサービス</strong>
                </td>
                <td className={`${TABLE_TD_CLASSNAME}`}>
                  <strong>対応する規約</strong>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={`${TABLE_TD_CLASSNAME} break-all`}>
                  外資就活ドットコム
                  <br />（
                  <CommonLink
                    href="https://gaishishukatsu.com/"
                    className="underline hover:opacity-80"
                  >
                    "https://gaishishukatsu.com"
                  </CommonLink>
                  ）
                </td>
                <td className={`${TABLE_TD_CLASSNAME} break-all`}>
                  外資就活ドットコムの利用に関するプライバシーポリシー
                  <br />（
                  <CommonLink
                    href="https://gaishishukatsu.com/service_privacy_policy"
                    className="underline hover:opacity-80"
                  >
                    "https://gaishishukatsu.com/service_privacy_policy"
                  </CommonLink>
                  ）
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className={`${TEXT_CLASSNAME}`}>以上</p>
      </Box>
    </>
  );
};
